<template>
  <div class="wrapper-content">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>Ajustes</h1>
    <p>En este sección puede configurar ciertos parámetros de la aplicación.</p>
    <b-tabs>
      <b-tab title="Decretos" active class="py-4">
        <h3>Opciones de PDF</h3>
        <b-row>
          <LmTextInput
            class="col-12 col-md-3"
            label="Título del encabezado"
            placeholder="Título del encabezado"
            v-model="settings.documents.pdfHeader"
          />
          <LmTextInput
            class="col-12 col-md-3"
            label="Subtítulo del encabezado"
            placeholder="Subtítulo del encabezado"
            v-model="settings.documents.pdfSubHeader"
          />

        </b-row>
        <b-row>
          <div class="col-12 mt-2">
            <label>Sección Decreta</label>
            <LmEditor
              v-model="settings.documents.pdfDecreta"
              :activeTable="false"
            />
          </div>
        </b-row>
      </b-tab>
      <b-tab title="Configuración de Firmas" class="py-4">
        <h3>Configuración de Firmas</h3>
        <b-row>
          <LmTextInput
            class="col-12 col-md-3"
            label="Cargo Secretario Reemplazante"
            placeholder="Cargo Secretario Reemplazante"
            v-model="settings.firmas.secretario"
          />
          <LmTextInput
            class="col-12 col-md-3"
            label="Cargo Reemplazante Intendente"
            placeholder="Cargo Reemplazante Intendente"
            v-model="settings.firmas.intendente"
          />
        </b-row>
        <b-row>
          <LmTextInput
            class="col-12 col-md-3"
            label="Cargo secretario titular"
            placeholder="Cargo para el secretario"
            v-model="settings.firmas.secretarioTitular"
          />
          <LmTextInput
            class="col-12 col-md-3"
            label="Cargo intendente/a"
            placeholder="Cargo para el intendente"
            v-model="settings.firmas.intendenteTitular"
          />
        </b-row>
      </b-tab>

      <b-tab title="Personalización" class="py-4" v-if="false">
        <h3>Personalización</h3>
        <b-row>
          <div class="col-12 col-md-3">
            <span class="d-block mb-2">Logo para el encabezado</span>
            <div class="img-wrap mt-2" v-b-modal.logo-1-cropper-modal v-if="appLogo1">
              <b-img class="img-preview" center thumbnail :src="appLogo1"></b-img>
              <div class="img-description-layer">
                <p class="img-description">Editar logo</p>
              </div>
            </div>
            <div
              v-else
              v-b-modal.logo-1-cropper-modal
              class="empty-logo d-flex justify-content-center align-items-center">
              <p class="mb-0">Carga un logo desde acá</p>
            </div>
          </div>

        </b-row>
      </b-tab>
    </b-tabs>
    <hr class="w-100">
    <LmButton
      :value="$t('save')"
      buttonClass="btn-primary"
      @click="onSave"
    />

    <b-modal id="logo-pdf-cropper-modal" no-close-on-backdrop title="Editar logo para encabezado" size="xl">
      <div id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperAppLogoPdf"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :viewMode="1"
            labelFile="Logo del encabezado"
            @input="settings.documents.pdfLogo = $event; closeCropper('logo-pdf-cropper-modal', 'lmCropperAppLogoPdf');"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click="cropImage('lmCropperAppLogoPdf')"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click="closeCropper('logo-pdf-cropper-modal', 'lmCropperAppLogoPdf')"
          />
        </div>
      </template>
    </b-modal>

    <b-modal id="logo-1-cropper-modal" no-close-on-backdrop title="Editar logo del encabezado" size="xl">
      <div id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperAppLogo1"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :viewMode="1"
            labelFile="Logo del encabezado"
            @input="settings.customization.appLogo1 = $event; closeCropper('logo-1-cropper-modal', 'lmCropperAppLogo1');"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click="cropImage('lmCropperAppLogo1')"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click="closeCropper('logo-1-cropper-modal', 'lmCropperAppLogo1')"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import LmProfileCropper from '@/components/LmProfileCropper.vue'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmButton from '@/components/form/elements/LmButton'
import LmEditor from '@/components/form/elements/lmEditor'

import { mapActions } from 'vuex'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmTextInput,
    LmColorPicker,
    LmUploadFiles,
    LmButton,
    LmProfileCropper,
    LmEditor
  },
  data () {
    return {
      isLoading: false,
      isImageLoadedToBeCrop: false,
      imageToCrop: '',
      mailertemplateOptions: [],
      settings: {
        documents: {
          pdfHeader: null,
          pdfSubHeader: null,
          pdfDecreta: null
        },
        firmas: {
          secretario: null,
          intendente: null,
          secretarioTitular: null,
          intendenteTitular: null
        }
      }
    }
  },
  computed: {
    pdfLogoPreviewSrc () {
      if (this.settings?.documents?.pdfLogo?.path) {
        return process.env.VUE_APP_API_URL_STATIC_ASSETS + this.settings.documents.pdfLogo.path
      }
      return null
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    async onSave () {
      try {
        this.isLoading = true
        // await commonsApi.axiosPutWrapper('/decretossettings/update', this.settings)
        let saveData = {
          documents: [{
            pdfHeader: this.settings.documents.pdfHeader,
            pdfSubHeader: this.settings.documents.pdfSubHeader,
            pdfDecreta: this.settings.documents.pdfDecreta
          }],
          firmas: [{
            intendente: this.settings.firmas.intendente,
            secretario: this.settings.firmas.secretario,
            secretarioTitular: this.settings.firmas.secretarioTitular,
            intendenteTitular: this.settings.firmas.intendenteTitular
          }]
        }
        try {
          await this.updateItemDetail({
            path: 'decretossettings/update/',
            data: saveData
          })
        } finally {
          this.isLoading = false
        }
        this.lmToastSuccessMessage('Se guardaron los cambios.', 'Se guardó exitosamente')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    cropImage (ref) {
      this.$refs[ref].crop()
      this.$refs[ref].submit()
    },

    closeCropper (id, ref) {
      this.$forceUpdate()
      this.$bvModal.hide(id)
      this.imageToCrop = ''
      this.$refs[ref].reset()
    },
    async setForm () {
      try {
        let datos
        this.isLoading = true
        try {
          datos = await commonsApi.axiosGetWrapper('decretossettings/detail/')
          /*
          datos = await this.getItemDetail({
            path: 'decretossettings/detail/'
          })
          */
          this.settings.documents.pdfHeader = datos.data.documents.pdfHeader[0]
          this.settings.documents.pdfSubHeader = datos.data.documents.pdfSubHeader[0]
          this.settings.documents.pdfDecreta = datos.data.documents.pdfDecreta[0]
          // Firmas
          this.settings.firmas.intendente = datos.data.firmas.intendente[0]
          this.settings.firmas.secretario = datos.data.firmas.secretario[0]
          this.settings.firmas.intendenteTitular = datos.data.firmas.intendenteTitular[0]
          this.settings.firmas.secretarioTitular = datos.data.firmas.secretarioTitular[0]
        } finally {
          this.isLoading = false
        }
        // this.lmToastSuccessMessage('Se guardaron los cambios.', 'Se guardó exitosamente')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  mounted () {
    this.setForm()
  }
}
</script>
<style lang="sass" scoped>
.empty-logo
  margin-top: 14px
  width: 300px
  height: 38px
  background-color: #eaeaea
  border-radius: 5px
  border: 2px dashed #d1d0d0
.img-wrap
  margin-top: 12px
  position: relative
  cursor: pointer
.img-preview
  max-width: auto
  height: 40px
.img-description-layer
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  border-radius: 5px
  background: var(--app-accent-color)
  color: #fff
  visibility: hidden
  opacity: 0
  display: flex
  align-items: center
  justify-content: center
  transition: opacity .2s, visibility .2s
.img-wrap:hover .img-description-layer
  visibility: visible
  opacity: 1
.img-description
  margin-bottom: 0
  transition: .2s
  transform: translateY(1em)
  text-transform: uppercase
.img-wrap:hover .img-description
  transform: translateY(0)
</style>
